import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { gateway_recommendation_type } from "../../enums";
import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
  useMerchantApiQuery,
} from "../../hooks";
import {
  IBusinessDetailsSettings,
  IBusinessType,
  IRevenueBracket,
} from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { businessDetailsValidationSchema } from "./validationSchema";

import { View } from "./View";

export const BusinessDetails = () => {
  const navigate = useNavigate();

  const { data } = useAccountSettings();

  const {
    isLoading: isLoadingRevenueBrackets,
    isSuccess: isSuccessRevenueBrackets,
    data: revenueBrackets,
  } = useMerchantApiQuery<IRevenueBracket[]>("getRevenueBrackets");

  const {
    isLoading: isLoadingBusinessTypes,
    isSuccess: isSuccessBusinessTypes,
    data: businessTypes,
  } = useMerchantApiQuery<IBusinessType[]>("getBusinessTypes");

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      // console.log("resetting the form...");
      accountSettings && reset(accountSettings);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: IBusinessDetailsSettings = {
    registered_business_name: "",
    registered_country: "",
    registered_business_type_id: "",
    registration_number: "",
    industry: "",
    business_email_address: "",
    business_website: "",
    business_terms_and_conditions_url: "",
    business_privacy_url: "",
    business_description: "",
    estimated_monthly_sale_id: "",

    business_address_line1: "",
    business_address_line2: "",

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<IBusinessDetailsSettings, IBusinessDetailsSettings>(
      "saveBusinessDetailsSettings"
    ).usePutMutation;

  const handleApiSubmit = (data: IBusinessDetailsSettings) => {
    saveSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset, watch } = useHookForm(
    {
      initialFormValues,
      validationSchema: businessDetailsValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    }
  );

  const registered_countryFormValue = watch("registered_country");

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  return (
    <View
      dataModificationDisabled={
        (data?.is_account_verification_completed &&
          data.is_account_verification_successful) ||
        true
      }
      registered_countryFormValue={registered_countryFormValue}
      isLoadingRevenueBrackets={isLoadingRevenueBrackets}
      revenueBrackets={revenueBrackets || []}
      isLoadingBusinessTypes={isLoadingBusinessTypes}
      businessTypes={businessTypes || []}
      goBack={goBack}
      isDirty={isDirty}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
